export default __webpack_public_path__ + "static/media/celine.cbef0dae.png";